import { render, staticRenderFns } from "./AccountProfileSubscriptionsPlans.vue?vue&type=template&id=466290dd&"
import script from "./AccountProfileSubscriptionsPlans.vue?vue&type=script&lang=js&"
export * from "./AccountProfileSubscriptionsPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports